
function About() {
  return <h2>About</h2>;
}
export default About;
